var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "m14.37 4.47 1.16 1.16L11.15 10l4.38 4.37-1.16 1.16L10 11.15l-4.37 4.38-1.16-1.16L8.85 10 4.47 5.63l1.16-1.16L10 8.85l4.37-4.38Z"
  })));
};
export default SvgClose;